<footer>
  <div class="footer">
    <div class="footer-wrapper">
      <div class="footer-wrapper-about footer-wrapper-item">
        <span class="item1">{{ "About Us" | translate }}</span>
        <span class="item2">{{ "We are a travel agency" | translate }}</span>
        <span class="item3">{{ "E-mail" | translate }}: info.tourdearmenia&#64;gmail.com</span>

        <div class="footer-language">
          <sf-dropdown
            [unSelectable]="false"
            [hasSearch]="false"
            [additionalClassName]="'lng-dropdown'"
            [selectedItem]="appStateService.selectedLanguage"
            [items]="appStateService.languages"
            (select$)="changeLanguage($event)"
          />
        </div>
      </div>

      <div class="footer-wrapper-newsletter footer-wrapper-item">
        <span class="item1">{{ "newsletter" | translate }}</span>
        <span class="item2">{{ "Stay update" | translate }}</span>
        <div class="input">
          <input type="text" [placeholder]="'enter email' | translate">
          <button>
            <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>

      <div class="footer-wrapper-findUs footer-wrapper-item">
        <div class="contact-findUS-title">
          <span>{{ "also find us" | translate }}</span>
        </div>

        <div class="contact-findUS-appText">
          <div class="contact-findUS-appText-item">
            <div class="logo">
              <img src="../../../../assets/img/phones/zangi.png" alt="Zangi">
            </div>
            <div class="phone">
              <span>+374 93 31 31 52</span>
            </div>
            <div class="app">
              <span>Zangi</span>
            </div>
          </div>

          <div class="contact-findUS-appText-item">
            <div class="logo otherSize">
              <img src="../../../../assets/img/phones/whatsApp.png" alt="WhatsApp">
            </div>
            <div class="phone">
              <span>+374 93 31 31 52</span>
            </div>
            <div class="app">
              <span>WhatsApp</span>
            </div>
          </div>

          <div class="contact-findUS-appText-item">
            <div class="logo otherSize">
              <img src="../../../../assets/img/phones/viber.png" alt="Viber">
            </div>
            <div class="phone">
              <span>+374 93 31 31 52</span>
            </div>
            <div class="app">
              <span>Viber</span>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div class="footer-copyright">
    <span class="item4">{{ "copyright" | translate }}</span>
  </div>
</footer>
